import {
  PackageTypes, PackageDetailTypes, Section, IPackageAddOnRequest, PackageAddOnTypes,
  PackageAddOnTypesDetail,
  PackageAddOnParams
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllPackageService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<PackageTypes[]>> => {
  const res = await axiosInstance.get('/service-packages', { params });
  return res.data;
};

export const getAllAddOnsPackageService = async (
  data: PackageAddOnParams
):
  Promise<APIPaginationResponse<PackageAddOnTypes[]>> => {
  const res = await axiosInstance.get(`/service-package-addons${data.duration ? `?duration[is][0]=${data.duration}` : ''}`, { params: data.params });
  return res.data;
};

export const getAddOnPackageDetailService = async (id: number):
  Promise<PackageAddOnTypesDetail> => {
  const res = await axiosInstance.get(`/service-package-addons/${id}`);
  return res.data.data;
};

export const postCreatePackageService = async (params: PackageDetailTypes): Promise<void> => {
  const res = await axiosInstance.post('/service-packages', params);
  return res.data;
};

export const getPackageDetailService = async (id: number): Promise<PackageTypes> => {
  const res = await axiosInstance.get(`/service-packages/${id}`);
  return res.data.data;
};

export const putUpdatePackageService = async (id: number, params: PackageDetailTypes)
  : Promise<void> => {
  const res = await axiosInstance.put(`/service-packages/${id}`, params);
  return res.data;
};

export const putUpdateAddOnPackageService = async (id: number, params: IPackageAddOnRequest)
  : Promise<void> => {
  const res = await axiosInstance.put(`/service-package-addons/${id}`, params);
  return res.data;
};

export const deletePackageByIdsService = async ({ ids }: { ids: number[] }): Promise<void> => {
  const res = await axiosInstance.delete('/service-packages', { data: { ids } });
  return res.data;
};

export const deleteAddOnPackageByIdsService = async ({ ids }: { ids: number[] }): Promise<void> => {
  const res = await axiosInstance.delete('/service-package-addons', { data: { ids } });
  return res.data;
};

export const updatePackageStatusService = async (id: number, status: number): Promise<void> => {
  await axiosInstance.put(`service-packages/${id}/update-status`, { status });
};

export const updateIsCheckoutStatusService = async (
  id: number,
  isCheckout: boolean
): Promise<void> => {
  await axiosInstance.put(`service-packages/${id}/update-checkout`, { isCheckout });
};

export const postPackageCompareService = async (data: Section[]): Promise<void> => {
  await axiosInstance.post('/system-general', { servicePackageCollaborate: data });
};

export const getPackageCompareService = async (): Promise<Section[]> => {
  const res = await axiosInstance.get('/system-general');
  return res.data.data.servicePackageCollaborate;
};

export const updateAddOnPackageStatusService = async (
  id: number,
  status: number
): Promise<void> => {
  await axiosInstance.put(`/service-package-addons/${id}/update-status`, { status });
};

export const updateAddOnPackageIsCheckoutService = async (
  id: number,
  isCheckout: boolean
): Promise<void> => {
  await axiosInstance.put(`/service-package-addons/${id}/update-checkout`, { isCheckout });
};

export const createAddOnsPackageService = async (data: IPackageAddOnRequest)
  : Promise<void> => {
  const res = await axiosInstance.post('/service-package-addons', data);
  return res.data;
};
